import loadable from '@loadable/component'

export default [
  {
    path: '/code/crossroompk/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-CrossRoomPkRule" */ '~/pages/r_code/CrossRoomPk/Rule'
        )
    ),
  },
  {
    path: '/code/crossroompk/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-CrossRoomPkRank" */ '~/pages/r_code/CrossRoomPk/Rank'
        )
    ),
  },
]
